import React, { Component } from 'react';
import Alert from 'components/alerts/Alert/Alert';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import './style.css';

class BookingSuccessAlert extends Component {
  static get propTypes() {
    return {
      onClose: PropTypes.func.isRequired,
      onRefer: PropTypes.func.isRequired,
    };
  }

  render() {
    return (
      <Alert className="booking-success" alertType="success">
        <button
          type="button"
          onClick={this.props.onClose}
          className="btn btn-cursor close-button"
        >
          X
        </button>
        <div className="d-flex align-items-center justify-content-center alert-content-stack">
          <div className="check-mark">
            <i className="far fa-check-circle fa-2x" />
          </div>
          <div className="congrats-text">
            <strong>Your lesson is booked!</strong>
          </div>
          {/* <div className="refer-text">
            Get $70 for each person you refer.
          </div>
          <div>
            <Link
              className="preferred-action"
              onClick={this.props.onRefer}
              to="https://www.rypeapp.com/refer/"
              target="_blank"
            >
              <button
                type="button"
                className="btn btn-secondary btn-cursor"
              >
                  Refer A Friend
              </button>
            </Link>
          </div> */}
        </div>
      </Alert>
    );
  }
}

export default BookingSuccessAlert;



// WEBPACK FOOTER //
// ./src/components/BookingSuccessAlert/index.js